module.exports = __webpack_public_path__ + "static/media/how-it-works-3.88380755.png";